export const GET_TASK_TREND = 'GET_TASK_TREND';
export const GET_TASK_TREND_SUCCESS = 'GET_TASK_TREND_SUCCESS';
export const GET_TASK_TREND_ERROR = 'GET_TASK_TREND_ERROR';
